/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IMedicine } from 'app/shared/model/medicine.model';
import { IRegimenDrug } from 'app/shared/model/regimen-drug.model';

export interface IDosageDilution {
  id?: string;
  diluentValue?: number | null;
  diluentUnit?: string | null;
  recommendedSolute?: string | null;
  soluteUnit?: number | null;
  solutetValue?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  solute?: IMedicine | null;
  diluent?: IMedicine | null;
  regimenDrug?: IRegimenDrug | null;
}

export const defaultValue: Readonly<IDosageDilution> = {
  active: false,
};
